import { render, staticRenderFns } from "./EditingTemplate_v2.vue?vue&type=template&id=5ff154a8&"
import script from "./EditingTemplate_v2.vue?vue&type=script&lang=js&"
export * from "./EditingTemplate_v2.vue?vue&type=script&lang=js&"
import style0 from "./EditingTemplate_v2.vue?vue&type=style&index=0&id=5ff154a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports